module.exports = __webpack_public_path__ + "img/montpellier-logo-icon.7d932724.png";